import { createAction, props } from '@ngrx/store';
import { Taskboard, CommunicationCategory, CommunicationStatus, CommunicationFile } from './taskboard.model';
import { Member } from '../Member/member.model';

// fetch 
export const fetchtaskboardListData = createAction('[Data] fetch taskboardList');
export const fetchtaskboardListSuccess = createAction('[Data] fetch taskboardList success', props<{ TaskboardListdata: Taskboard[] }>())
export const fetchtaskboardListFail = createAction('[Data fetch taskboardList failed]', props<{ error: string }>())

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records club management'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records club management success', 
    props<{ listData: Taskboard[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records club management failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record club management',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record club management success', 
    props<{ dummyId:string, singleData: Taskboard, files: CommunicationFile[], statuses: CommunicationStatus[], categories: CommunicationCategory[], members: Member[] }>()
);

export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record club management failure', 
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record club management',
    props<{ id: string; isNew: boolean, updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record club management success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record club management failure',
    props<{ error: string }>()
);

// Delete File
export const deleteFileRecord = createAction(
    '[Data] Delete record club file',
    props<{ taskId: string, id: string }>()
);
export const deleteFileRecordSuccess = createAction(
    '[Data] Delete record club file success'
);
export const deleteFileRecordFailure = createAction(
    '[Data] Delete record club file failure',
    props<{ error: string }>()
);

//Mark Read
export const markRead = createAction(
    '[Data] Mark task chat as read',
    props<{ id: string }>()
);

export const markReadSuccess = createAction(
    '[Data] Mark task chat as read success'
);

export const markReadFailure = createAction(
    '[Data] Mark task chat as read failure',
    props<{ error: string }>()
);

//Mark As Done
export const markAsDone = createAction(
    '[Data] Mark task as done',
    props<{ id: string }>()
);

export const markAsDoneSuccess = createAction(
    '[Data] Mark task as done success'
);

export const markAsDoneFailure = createAction(
    '[Data] Mark task as done failure',
    props<{ error: string }>()
);


//Fetch Unread
export const fetchUnread = createAction(
    '[Data] Fetch task unread chat'
);

export const fetchUnreadSuccess = createAction(
    '[Data] Fetch task unread chat success'
);

export const fetchUnreadFailure = createAction(
    '[Data] Fetch task unread chat failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state club management',
);